<template>
    <div style="display:grid; gap:15px">
        <h3>Seguimiento de alarmas de operarios</h3>
        <div style="display:grid; grid-template-columns: 3fr 2fr 2fr 3fr 2fr 1fr 1fr; gap: 15px">
            <div style="display:flex; justify-content:center; gap:5px">
                <input type="date" class="form-control form-control-sm" v-model="fecha_inicio">
                <input type="date" class="form-control form-control-sm" v-model="fecha_fin">
            </div>
            <input v-model="filtro_servicio" placeholder="Filtrar servicio" type="text" class="form-control form-control-sm">
            <input v-model="filtro_nota" placeholder="Filtrar nota" type="text" class="form-control form-control-sm">
            <select class="form-control form-control-sm" v-model="usuario_de_seleccionado">
                <option value="">-- Filtro de --</option>
                <option v-for="usuario in usuarios_de" :key="usuario.idusuario" :value="usuario.idusuario" :title="usuario.completo">{{ usuario.nombre }}</option>
            </select>        
            <input v-model="filtro_comentario" placeholder="Filtrar comentario" type="text" class="form-control form-control-sm">
            <select name="" id="" v-model="filtro_resuelto" class="form-control form-control-sm">
                <option value="">---</option>
                <option value="0">No</option>
                <option value="1">Si</option>
            </select>
            <button class="btn btn-sm btn-primary" @click="obtenerListado">Buscar</button>
        </div>
        <tabla-datos :botoncrear="1" @quieroDatos="obtenerListado($event);" :total="total" :columnas="columnas" 
        :datos="expedientes" :filtros="false">
        </tabla-datos>
    </div>
</template>
<script>
import TablaDatos from '../TablaDatos.vue';
import { PwgsApi } from '../../services/PwgsApi';
export default {
    props:[],
    components:{
        "tabla-datos": TablaDatos,        
    },
    data(){
        return{
            url_global: localStorage.getItem('direccion'),
            expedientes: [],
            total:0,
            filtro_resuelto:'',
            filtro_servicio: '',
            filtro_nota: '',
            filtro_comentario: '',
            usuarios_de:[],
            usuario_de_seleccionado: '',
            fecha_inicio: '',
            fecha_fin: '',
            columnas: [
                //juntar fecha y hora
                {
                    header: 'Fecha',
                    field: 'fecha',
                },
                {
                    header: 'Servicio',
                    field: 'codigo',
                    acciones: [
                        {
                            link: true,
                            tipo: 'default',
                            nombreId: 'id_servicio',
                            accion: (id) => {
                                let direccion = localStorage.getItem('direccion');
                                if(direccion == 'null.pwgs.app') direccion = 'pwgs.raul.pwgs5.interno.apuyen.app';
                                let aux = "https://" + direccion + "/seguimiento.php?servicio="+id;
                                window.open(aux,'_blank');                                
                            }
                        }
                    ]
                },
                {
                    header: 'Nota',
                    field: 'texto_nota',
                },
                {
                    header: 'De',
                    field: 'de_usuario',
                },
                {
                    header: 'A',
                    field: 'a_usuario',
                },
                {
                    header: 'Comentario Resuelto',
                    field: 'nota_alarma',
                },
                {
                    header: '',
                    field: 'activa',
                },
            ]
        }
    },
    methods:{
        cargarDatos(){
            this.cargarUsuarios();
            this.fecha_inicio = this.diaActual();
            this.fecha_fin = this.diaActual();
            this.obtenerListado();
        },
        async obtenerListado(event){
            const api = new PwgsApi();
            if(!event) event = {};
            if(!event.rows){
                event.rows = 15;
                event.page = 0;
            }
            event.modo = 'operarios';
            event.servicio = this.filtro_servicio;
            event.nota = this.filtro_nota;
            event.comentario = this.filtro_comentario;
            event.resuelto = this.filtro_resuelto;
            event.usuario_de = this.usuario_de_seleccionado;
            event.fecha = this.formatearFecha(this.fecha_inicio);
            event.fecha_fin = this.formatearFecha(this.fecha_fin);
            const resp = await api.post('seguimiento-alarmas',event);
            resp.datos.forEach(element => {
                element.fecha = element.fecha + ' ' + element.hora;
            });
            this.expedientes = resp.datos;
            this.total = resp.n_total_registros;
        },
        async cargarUsuarios() {
            const api = new PwgsApi();
            var resp = await api.get('/usuarios-alarmas-operarios');            
            this.usuarios_de = resp;
        },
        diaActual() {
          const hoy = new Date();
          return hoy.toISOString().split('T')[0];  
        },
        formatearFecha(fecha) {
            const partes = fecha.split('-');
            return `${partes[2]}/${partes[1]}/${partes[0]}`;
        }
    },
    mounted(){
        this.cargarDatos();
    }
}

</script>
